import { WorkerForWork } from '@types';
import { FlexworkerColumnDefinition } from '../flex-workers-for-work-table.types';

export const getFlexworkerTableData = (
  flexWorkers: WorkerForWork[],
  entityId: string
): FlexworkerColumnDefinition[] => {
  return flexWorkers.map((fw) => {
    return {
      ...fw,
      flexWorkerImage: {
        ...fw.flexWorkerImage,
        id: fw.flexWorkerId,
        employmentType: fw.employmentType,
      },
      actions: {
        entityId,
        flexWorkerId: fw.flexWorkerId,
        flexWorkerName: fw.flexWorkerFullName,
      },
      availability: fw.availability,
      experienceInMonths: fw.experienceInMonths,
    };
  });
};
